import script from "./UserDirectory.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDirectory.vue?vue&type=script&setup=true&lang=js"

import "./UserDirectory.vue?vue&type=style&index=0&id=da33cbbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da33cbbe"]])

export default __exports__